module.exports = __webpack_public_path__ + "img/headimg.970ccb8f.png";